<!--
 * @Author: Merlin
 * @Date: 2023-12-07 17:18:44
 * @LastEditors: Gaho
 * @LastEditTime: 2024-06-10 10:41:43
 * @Description: 
-->
<template>
    <article class="RTP-body"
        :class="type == 'old' ? 'old' : 'new'"
    >
        <div class="rtp-wrap__text" v-if="type == 'old'" >
            ⚡RTP:
        </div>
        <div class="rtp-wrap__text" v-else >
            RTP
        </div>
        <div class="rtp-wrap__value" >
            <ClientOnly>
                {{ RTPValue }}
            </ClientOnly>
        </div>
        <div class="icon"
            @click="visibleControl(null)"
            @mouseenter="mouseEntered"
            @mouseleave="visibleControl(false)" 
        >
            <IconSvgUse width="20" height="20" use="icon-question" />
            <q-tooltip
                anchor="top middle"
                self="bottom middle"
                max-height="300px"
                class="the_wrap_for_RTP_tips"
                v-model="bNewStatus"
            >
                <article class="RTP_tip_content">
                    <h6 class="title">
                        <span>{{ $t('RTP_tip.RTP') }}</span>
                        <em class="value">
                            <ClientOnly>
                                {{ RTPValue }}
                            </ClientOnly>
                        </em>
                    </h6>
                    <p class="content">
                        {{ $t('RTP_tip.RTP_description') }}
                    </p>
                    <hr/>
                    <h6 class="title">
                        <span>{{ $t('RTP_tip.eRTP') }}</span>
                        <em class="value">
                            <ClientOnly>
                                {{ eRTPValue }}
                            </ClientOnly>
                        </em>
                    </h6>
                    <p class="content">
                        {{$t('RTP_tip.eRTP_description')}}
                    </p>
                    <i class="narrow"></i>
                </article>
            </q-tooltip>
        </div>
    </article>
</template>

<script>
import { useJoinStateStore } from '@/stores/cansino/joinState';
import lightImage from '@/assets/imgs/casino/lightning-bolt.webp';
export default {
    props: {
        type: {
            type: String, // old
            default: '',
        },
        // RTPValue: {
        //     type: Number,
        //     default: 99.02,
        // }
    },
    data(){
        return {
            lightImage,
            oTipBody: null,
            isIntersecting: false,
            bNewStatus: false, // 最新状态 
        };
    },
    computed: {
        RTPValue(){
            return useJoinStateStore().config.rtp;
        },
        eRTPValue(){
            const { ertp } = useJoinStateStore().config;
            return `${ertp[0]} - ${ertp[ertp.length - 1]}`
        },
    },
    methods:{
        mouseEntered(){
            if ('ontouchstart' in window){
                return; // 移动设备下由点击事件控制可见性，故此终止 
            }
            this.bNewStatus = true;
        },
        visibleControl(newVal){
            if (typeof newVal === 'boolean'){
                this.bNewStatus = newVal;
            }else{
                this.bNewStatus = !this.bNewStatus; 
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.RTP-body{
    --radio: 32px;
    display: flex;
    align-items: center;
    border-radius: var(--radio);
    font-size: 14px;
    justify-content: center;
    letter-spacing: -.02em;
    line-height: 18px;
    max-width: 160px;
    padding: 7px 12px;
    position: relative;
    z-index: 2;
    @media (max-width: 576px) {
        align-items: center;
        margin-top: 16px;
    }
    .rtp-wrap__text{
        cursor: default;
    }
    .rtp-wrap__value{
        cursor: default;
        margin: 0 6px 0 4px;
        font-weight: 600;
    }
    &[class~=old]{
        background: #1c2532;
        .rtp-wrap__text{
            color: #55657e;
            font-weight: 600;
        }
        .rtp-wrap__value{
            color: #93acd3;
            margin: 0 5px 0 3px;
        }
    }
    &[class~=new]{
        background: linear-gradient(108.63deg,rgba(42,53,70,.44) 27.93%,rgba(42,53,70,.44) 62.61%);
        &:before{
            content: "";
            display: block;
            background-image: url(@/assets/imgs/casino/lightning-bolt.webp);
            background-repeat: no-repeat;
            background-position-x: -6px;
            background-position-y: bottom;
            background-size: 60px auto;
            width: 50%;
            pointer-events: none;
            position: absolute;
            height: 100%;
            bottom: 0px;
            left: 0;
            /* outline: solid 1px yellow; */
        }
        .rtp-wrap__text{
            color: white;
            font-weight: 600;
            padding-left: 30px;
        }
        .rtp-wrap__value{
            font-weight: 600;
            -webkit-text-fill-color: transparent;
            text-fill-color: transparent;
            background: linear-gradient(91.34deg,#e8ba4b 2.8%,#ff7967 102.8%);
            -webkit-background-clip: text;
            background-clip: text;
        }
    }
}

.icon{
    cursor: pointer;
    position: relative;
    svg{
        color: #55657e;
    }
}
</style>


<style lang="scss">
// ▼全局样式，非 scoped !!!
.q-tooltip[class ~= the_wrap_for_RTP_tips]{
    overflow-x: visible !important;
    overflow-y: visible !important;
    background: transparent;
    padding: 0;
    .RTP_tip_content{
        --bg-color: #202a39;
        padding: 15px 15px 8px;
        background: var(--bg-color);
        border-radius: 8px;
        color: #93acd3;
        font-size: 12px;
        line-height: 18px;
        width: 230px;
        filter: drop-shadow(2px 2px 20px rgba(0,0,0,.3));
        box-shadow: 0 6px 20px rgba($color: #000000, $alpha: 0.5);
        hr{
            width:100%;
            height: 1px;
            background: #263041;
            border: none;
            margin: 8px 0;
        }
        .title{
            display: flex;
            justify-content: space-between;
            line-height: 1.6;
            font-weight: 500;
            .value{
                color:white;
                font-style: normal;
            }
        }
        .content{
            width: 190px;
            padding: 0.2em 0 0.5em;
            // text-align: justify;
        }
        .narrow{
            display: block;
            position: absolute;
            border-style: solid;
            border-color: var(--bg-color) transparent transparent transparent;
            // border-color: var(--bg-color) transparent yellow transparent;
            border-width: 10px 10px;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 99%);
        }
    }
}

</style>
